import { Model, MapTo } from 'src/app/decorators/mapto';

export class CustomerModel extends Model {
    @MapTo()
    id: string;
    @MapTo()
    name: string;
    @MapTo()
    company_name: string;
    @MapTo()
    email: string;
    @MapTo()
    website: string;
    @MapTo()
    contact_number: string;
    @MapTo()
    city: string;
    @MapTo()
    orgResourceId: string;
    @MapTo()
    province: string;
    @MapTo()
    address: string;
    @MapTo()
    country: string;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }

    get ContactWithoutCountryCode(): string {
        if (this.contact_number) {
            const number = this.contact_number.replace('+92', '0');
            return number;
        }
    }
}
